/*
 * Header.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { Link, NavLink, useNavigate } from "react-router-dom";
import { localization } from "../../config/localize/localizable";

const Header = () => {
  const navigate = useNavigate();
  // const { profile } = useUser();
  // const { logOut } = useAuth();
  const logOut = () => {
    navigate("/", { replace: true });
  };
  return (
    <header className="grid grid-cols-5 p-2 ">
      <h1 className="col-span-2 text-2xl font-bold"> </h1>
      <div className="col-span-3  text-left  pl-4">
        <div className="left-0">
          {true ? (
            <>
              {/* <NavLink to={"/factor"}>فاکتور</NavLink> */}
              <button onClick={logOut}>خروج</button>
            </>
          ) : (
            <>
              <NavLink to={"/login"}>ورود</NavLink>
              <NavLink to={"/signup"}>ثبت نام</NavLink>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
